import { Component, inject, input, Input } from "@angular/core";
import { Router } from "@angular/router";
import { GuideWizardService } from "@vault/web-vault/app/services/guideWizard/guide-wizard.service";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-task-info-tooltips",
  templateUrl: "./task-info-tooltips.component.html",
})
export class TaskInfoTooltipsComponent {
  guideTitle = input("");
  @Input() tooltipLayout: "fixed" | "fixedCentered" | "overlayRight" | "inline" = "fixed";
  @Input() set mobileCentered(value: boolean) {
    this.tooltipLayout = value ? "fixedCentered" : "fixed";
  }
  @Input() taskTitle!: string;
  @Input() taskDescription!: string;
  @Input() subTaskDescription?: string;
  @Input() bottomAction: "back" | "return" | "none" = "back";
  private _currentStepRaw: number = 0;
  get currentStep(): number {
    return Math.min(this._currentStepRaw, this._totalSteps);
  }
  @Input() set currentStep(value: number) {
    this._currentStepRaw = value;
  }
  private static readonly DEFAULT_TOTAL_STEPS = 3;
  private _totalSteps: number = TaskInfoTooltipsComponent.DEFAULT_TOTAL_STEPS;
  get steps(): number[] {
    return Array.from({ length: this._totalSteps }, (_, i) => i + 1);
  }
  @Input() set totalSteps(value: number) {
    this._totalSteps = value;
  }

  get containerClass(): string {
    const layoutMap: Record<string, string> = {
      overlayRight: "tooltip-overlay-right",
      fixedCentered: "tooltip-fixed-centered",
      inline: "tooltip-inline",
    };
    return layoutMap[this.tooltipLayout] ?? "tooltip-fixed";
  }

  protected router: Router = inject(Router);
  protected guideWizardService: GuideWizardService = inject(GuideWizardService);
  private dialogRef = inject(MatDialogRef, { optional: true }) as MatDialogRef<unknown> | null;

  async goBackToGuide() {
    this.dialogRef?.close();

    if (this.guideTitle() && this.guideTitle() !== "tryAgainLaterInTutorial") {
      await this.guideWizardService.completeTask(
        this.guideWizardService.getTaskByGuideTitle(this.guideTitle()),
      );
    }
    await this.router.navigate(["/guide"]);
  }
}
